import { useLocation, useNavigate } from "react-router-dom";
import { AddressDetailCard, Attention, OrderDetail, UserCard } from "./helper";
import { goToLink } from "../../projectData";
import SafetyDisclaimerModal from "../../../component/disclimerPopup";
import { getAddressVerification } from "./api";
import { useEffect, useState } from "react";
import { FullPageLoader } from "../../../component/helper";

/**
 * AddressVerificationLink
 * Renders the address verification page, fetches and displays order/address details, and handles navigation.
 */
const AddressVerificationLink = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('request')
    const [orderData] = useState({
        "address": {
            "id": 12,
            "attention_required": "yes",
            "user_id": 29,
            "company_id": 1,
            "project_id": null,
            "address_status_id": 1,
            "address_type": "Other",
            "address1": "14B, Phase 8B, Industrial Area",
            "address2": "MAT Home Furnishings Pvt. Ltd.",
            "address3": "Kisanpura Road, Near Metro Station",
            "landmark": "Opposite Dhakoli Gurudwara",
            "city": "Zirakpur",
            "district": "SAS Nagar (Mohali)",
            "state": "Punjab",
            "pincode": "160104",
            "pincode_id": 5695458,
            "updated_by": null,
            "status": 1,
            "remarks": "Main warehouse address for large deliveries.",
            "status_remarks": null,
            "created_at": "2024-07-16T07:31:14.000000Z",
            "updated_at": "2025-01-31T06:39:47.000000Z",
            "deleted_at": null,
            "first_name": "Lalit",
            "last_name": "Prasad",
            "phone": "7310851506",
            "iirpl_sap_code": "U-IIRPL-244846"
        },

        "orders": {
            "order_id": "7EZFLF2MDU",
            "order_date": "29 Jan 2025",
            "items": [
                {
                    "id": 19,
                    "sku_name": "Nova Lint Remover",
                    "sku_type": "physical-gift",
                    "quantity": 1,
                    "tds": "0.24",
                    "ref_number": "QPRQNZY363",
                    "order_id": "7EZFLF2MDU",
                    "sub_order_id": "QPRQNZY363-S1",
                    "image_url": "https://ww1.iirpldev.com/storage/sku/1/x9GiIMf4RsNxuMwZ7OMpRhYAXil8j4CUEhecScWH.png",
                    "status": "In Process",
                    "address1": "14b",
                    "address2": "rehmat homes",
                    "address3": "kisanpura",
                    "landmark": "dhakoli",
                    "project_id": 1,
                    "phone": "7310851506",
                    "city": "mohali",
                    "pincode": "160104",
                    "state": "Haryana",
                    "district": "Panchkula",
                    "address_status": "Verified By Calling",
                    "address_verify_status": 3,
                    "address_type": "Home",
                    "user_address_id": 12
                },
                {
                    "id": 19,
                    "sku_name": "Nova Lint Remover",
                    "sku_type": "physical-gift",
                    "quantity": 1,
                    "tds": "0.24",
                    "ref_number": "QPRQNZY363",
                    "order_id": "7EZFLF2MDU",
                    "sub_order_id": "QPRQNZY363-S1",
                    "image_url": "https://ww1.iirpldev.com/storage/sku/1/x9GiIMf4RsNxuMwZ7OMpRhYAXil8j4CUEhecScWH.png",
                    "status": "In Process",
                    "address1": "14b",
                    "address2": "rehmat homes",
                    "address3": "kisanpura",
                    "landmark": "dhakoli",
                    "project_id": 1,
                    "phone": "7310851506",
                    "city": "mohali",
                    "pincode": "160104",
                    "state": "Haryana",
                    "district": "Panchkula",
                    "address_status": "Verified By Calling",
                    "address_verify_status": 3,
                    "address_type": "Home",
                    "user_address_id": 12
                },
                {
                    "id": 19,
                    "sku_name": "Nova Lint Remover",
                    "sku_type": "physical-gift",
                    "quantity": 1,
                    "tds": "0.24",
                    "ref_number": "QPRQNZY363",
                    "order_id": "7EZFLF2MDU",
                    "sub_order_id": "QPRQNZY363-S1",
                    "image_url": "https://ww1.iirpldev.com/storage/sku/1/x9GiIMf4RsNxuMwZ7OMpRhYAXil8j4CUEhecScWH.png",
                    "status": "In Process",
                    "address1": "14b",
                    "address2": "rehmat homes",
                    "address3": "kisanpura",
                    "landmark": "dhakoli",
                    "project_id": 1,
                    "phone": "7310851506",
                    "city": "mohali",
                    "pincode": "160104",
                    "state": "Haryana",
                    "district": "Panchkula",
                    "address_status": "Verified By Calling",
                    "address_verify_status": 3,
                    "address_type": "Home",
                    "user_address_id": 12
                },





            ]
        },
        "token": "34756783465"
    });
    const [loader, setLoader] = useState(true)

    useEffect(() => {
        if (token) {
            getAddressVerification({ request_token: token })
                .then((response) => {
                    if (response.code === '0') {
                        goToLink(navigate, '/customer/address/notFound');
                    } else {
                        // setOrderData(response?.data);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching address verification:", error);
                })
                .finally(() => {
                    setTimeout(() => {
                        setLoader(false);
                    }, 500);
                });
        }
    }, [token, navigate])

    return (
        <>
            {!loader ?
                <><SafetyDisclaimerModal />
                    <Attention />
                    <UserCard addressData={orderData?.address} />

                    <AddressDetailCard addressData={orderData?.address} />

                    <OrderDetail orders={orderData?.orders} />
                    <div className="d-flex w-100 align-items-center justify-content-center gap-4 mt-3">
                        <button onClick={() => goToLink(navigate, '/customer/address/update', orderData)} className={'btn w-50 text-white bg-dark bg-hover-success'}>Update  Address</button>
                        <button onClick={() => goToLink(navigate, '/customer/address/re-confirm', orderData)} className='btn  w-50 text-white bg-danger bg-hover-success'> Confirm Address</button>
                    </div></>
                :
                <FullPageLoader />}
        </>
    )

}

export default AddressVerificationLink